import React, { useMemo } from 'react'
import ReactCalendar from 'react-calendar'

import s from './styles.module.scss'

import { IconSvg } from '../../../atoms'
import useTimezoneConverter from '../../../organisms/dates-calendar/useTimezoneConverter'

const CustomCalendar = ({
  startDate: _startDate,
  endDate: _endDate,
  setDate: _setDate,
  closeModal,
  activeStartDate,
  setActiveStartDate,
  displayPastDates = false,
}: {
  startDate?: Date
  endDate?: Date
  setDate: ({
    startDate,
    endDate,
  }: {
    startDate?: Date
    endDate?: Date
  }) => void
  closeModal?: () => void
  activeStartDate: Date
  setActiveStartDate: React.Dispatch<React.SetStateAction<Date>>
  displayPastDates?: boolean
}) => {
  const { startDate, endDate, setDate } = useTimezoneConverter({
    startDate: _startDate,
    endDate: _endDate,
    setDate: _setDate,
    houseAvailabilities: [],
  })

  const value = useMemo(() => {
    if (endDate === null) {
      return startDate ? startDate : null
    }
    return startDate ? [startDate, endDate] : [null, null]
  }, [startDate, endDate])
  return (
    <ReactCalendar
      tileClassName={({ date }: { date: Date }): string | null => {
        if (!displayPastDates && date < new Date()) {
          return s.past
        }
        return null
      }}
      className={s.calendar}
      minDate={!displayPastDates ? new Date() : undefined}
      nextLabel={
        <div className={s.navMonth}>
          <IconSvg.IconCalendarNext />
        </div>
      }
      prevLabel={
        <div className={s.navMonth}>
          <IconSvg.IconCalendarPrev />
        </div>
      }
      next2Label={<></>}
      prev2Label={<></>}
      minDetail='month'
      maxDetail='month'
      defaultView='month'
      onChange={(value: any) => {
        if (endDate === null) {
          setDate({
            startDate: value ? value : undefined,
            endDate: undefined,
          })
          if (value[0] && closeModal) {
            closeModal()
          }
        } else {
          setDate({
            startDate: value[0] ? value[0] : undefined,
            endDate: value[1] ? value[1] : undefined,
          })
          if (value[1] && closeModal) {
            closeModal()
          }
        }
      }}
      showDoubleView={true}
      value={value as any}
      selectRange={true}
      showNeighboringMonth={false}
      allowPartialRange={true}
      activeStartDate={activeStartDate}
      onActiveStartDateChange={({ action, activeStartDate }) => {
        if (action === 'onChange' || !activeStartDate) {
          return
        }
        setActiveStartDate(activeStartDate)
      }}
      locale='fr-FR'
    />
  )
}

export default CustomCalendar
